<template>
  <div class="product-template __base">
    <product-detail :title="title" :product="product" v-if="product"></product-detail>
  </div>
</template>

<script>
import ProductDetail from '@/components/ProductDetail'

export default {
  name: 'ProductBaseTemplate',
  components: { ProductDetail },
  props: {
    product: { type: Object, required: true },
    title: { type: String, default: 'บริจาค' }
  }
}
</script>



// WEBPACK FOOTER //
// base.vue?6829d4c8